// extracted by mini-css-extract-plugin
module.exports = {"root":"_fe21ae","learnMoreAboutReviews":"_19b1e0"};